import $ from 'jquery';
import Chart from 'chart.js';
import 'chartjs-plugin-labels';

const padding = 50;
const mobileBreakpoint = 1240;

const defaultOptions = {
    cutoutPercentage: 20,
    rotation: -1 * Math.PI,
    layout: {
        padding: {
            left: padding,
            right: padding,
            top: padding,
            bottom: padding,
        },
    },
    maintainAspectRatio: false,
    legend: {
        display: false,
    },
    plugins: {
        labels: [
            {
                render: (args) => `${args.value}%`,
                fontColor: '#000',
                position: 'outside',
                fontSize: 32,
                fontStyle: 'bold',
                fontFamily: '"Open Sans"',
                textMargin: 15,
            },
            {
                render: (args) => `\n\n\n${args.label}`,
                fontColor: '#123',
                position: 'outside',
                fontSize: 22,
                fontFamily: '"Open Sans"',
                textMargin: 15,
            },
        ],
    },
};

const mobileOptions = {
    cutoutPercentage: 20,
    rotation: -1 * Math.PI,
    layout: {
        padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
        },
    },
    maintainAspectRatio: false,
    legend: {
        display: false,
    },
    plugins: {
        labels: [
            {
                render: (args) => `${args.value}%`,
                fontColor: '#000',
                position: 'border',
                fontSize: 14,
                fontStyle: 'bold',
                fontFamily: '"Open Sans"',
            },
            {
                render: (args) => `\n\n${args.label}`,
                fontColor: '#123',
                position: 'border',
                fontSize: 12,
                fontFamily: '"Open Sans"',
            },
        ],
    },
};

export default function initChart($chart) {
    $chart.each((index, element) => {
        const labelsData = $(element)
            .data('labels');
        const valuesData = $(element)
            .data('values');
        const backgroundsData = $(element)
            .data('backgrounds');

        const ctx = element.getContext('2d');
        const myChart = new Chart(ctx, {
            type: 'pie',
            data: {
                labels: labelsData,
                datasets: [{
                    data: valuesData,
                    backgroundColor: backgroundsData,
                    borderColor: 'rgba(255, 255, 255, 1)',
                    borderWidth: 3,
                }],
            },
            options: isMobile() ? mobileOptions : defaultOptions,
        });

        $(window)
            .resize(() => {
                responsiveOptions(myChart);
            });
    });
}

function responsiveOptions(myChart) {
    // eslint-disable-next-line no-param-reassign
    myChart.options = isMobile() ? mobileOptions : defaultOptions;
    myChart.update();
}

function isMobile() {
    const width = $(document)
        .width();
    return width < mobileBreakpoint;
}
